import React from 'react';

import { SpinnerItem } from './styles';

const Spinner: React.FC = () => {
	return <SpinnerItem />;
};

export default Spinner;
